import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  title: 'Edit video',
  back: 'Back',
  tipHeader: 'Instructions',
  tip1: 'The <strong>"Add video"</strong> button lets you pick media from your library or generate AI images and clips.',
  tip2: '<strong>Edit the script</strong> to change the audio connected your chosen segment. You can adjust the content, language and narration settings.',
  tip3: '<strong>Regenerate</strong> reprocesses only the selected clip based on its linked page.',
  tip4: '<strong>Mute audio</strong> hides the sound for that segment.',
  editVideoOptions_EditScript: 'Edit script',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Regenerate',
  editVideoOptions_ChangeMedia: 'Replace with Storyblocks',
  editVideoOptions_ChangeMediaLibrary: 'Replace with media library',
  editVideoOptions_ReplaceAIMedia: 'Replace AI-generated media',
  editVideoOptions_Delete: 'Delete',
  editVideoOptions_EditNarration: 'Edit narration',
  editVideoOptions_ConfirmDelete: 'Are you sure you want to delete this clip?',
  editVideoOptions_Disabled: 'Editing disabled for this clip',
  editNarrationModalTitle: 'Edit narration',
  editNarrationModalSave: 'Save',
  editNarrationSuccess: 'Narration updated successfully',
  emptyChunkPreview: 'No clip selected for preview',
  stateRegenerating: 'Saving video',
  stateChangingMedia: 'Changing media',
  stateMutingAudio: 'Muting audio',
  stateReplacingWithLibrary: 'Replacing with Media library',
  stateReplacingAIMedia: 'Replacing AI-generated media',
  stateChangingNarration: 'Updating narration',
  stateWorking: 'Working...',
  replaceAIMediaModalTitle: 'Replace AI-generated media',
  replaceAIMediaReplace: 'Replace',
  replaceAIMediaChange: 'Change',
  replaceAIMediaRemove: 'Remove',
  replaceAIMediaSave: 'Save',
  replaceAIMediaNoArtifacts: 'No media available for this clip',
  replaceAIMediaSuccess: 'AI media replacement started',
  replaceAIMediaOnlyOneVideo:
    'Only one video replacement is supported per operation',
  stateDisablingBackgroundAudio: 'Removing background music',
  removeBackgroundMusic: 'Remove background music',
  confirmRemoveBackgroundMusic:
    'This will permanently remove the background music from the video, once the changes are saved.',
  confirmRemoveBackgroundMusicAccept: 'Yes, remove',
  addMedia: 'Add media',
  addMediaFromLibrary: 'Add from library',
  addMediaFromStoryblocks: 'Add from Storyblocks',
  addMediaRemoveAudio: 'Remove audio',
  addMediaPending:
    'Adding media is taking longer than expected. Please check the timeline in a minute.',
  addMediaWait: 'Please wait until the current processing finishes.',
  editNarrationLoadFailed: 'Failed to load narration text',
};

const welsh = {
  title: 'Golygu Ffynhonnell y Fideo',
  back: 'Yn ôl',
  tipHeader: 'Cyfarwyddiadau',
  tip1: 'Mae\'r botwm <strong>"Ychwanegu fideo"</strong> yn eich galluogi i ddewis cyfryngau o\'ch llyfrgell neu gynhyrchu delweddau a clipiau AI.',
  tip2: "<strong>Golygu'r sgript</strong> i newid y sain sy'n gysylltiedig â'r segment a ddewiswyd. Gallwch addasu'r cynnwys, y iaith a'r gosodiadau darllen.",
  tip3: '<strong>Ailgynhyrchu</strong> yn ailbrosesu dim ond y clip a ddewiswyd yn seiliedig ar ei dudalen gysylltiedig.',
  tip4: "<strong>Mute audio</strong> yn cuddio'r sain ar gyfer y segment hwnnw.",
  editVideoOptions_EditScript: 'Golygu sgript',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Ailgynhyrchu',
  editVideoOptions_ChangeMedia: 'Newid cyfryngau',
  editVideoOptions_ChangeMediaLibrary: 'Newid cyfryngau',
  editVideoOptions_ReplaceAIMedia: 'Disodli cyfryngau AI',
  editVideoOptions_Delete: 'Dileu',
  editVideoOptions_EditNarration: 'Golygu adroddiad',
  editVideoOptions_ConfirmDelete: "Ydych chi wir eisiau dileu'r clip hwn?",
  editVideoOptions_Disabled: 'Mae golygu wedi’i analluogi ar gyfer y clip hwn',
  editNarrationModalTitle: 'Golygu adroddiad',
  editNarrationModalSave: 'Cadw',
  editNarrationSuccess: "Adroddiad wedi'i ddiweddaru'n llwyddiannus",
  emptyChunkPreview: "Dim darn wedi'i ddewis ar gyfer rhagolwg",
  stateRegenerating: 'Ail-greu fideo',
  stateChangingMedia: 'Newid cyfryngau',
  stateMutingAudio: 'Tawelu sain',
  stateReplacingWithLibrary: 'Yn disodli gyda chyfrwng y llyfrgell',
  stateReplacingAIMedia: 'Yn disodli cyfryngau AI',
  stateChangingNarration: 'Diweddaru adroddiad',
  stateWorking: 'Gweithio...',
  replaceAIMediaModalTitle: 'Disodli cyfryngau AI',
  replaceAIMediaReplace: 'Disodli',
  replaceAIMediaChange: 'Newid',
  replaceAIMediaRemove: 'Tynnu',
  replaceAIMediaSave: 'Cadw',
  replaceAIMediaNoArtifacts: 'Dim cyfryngau ar gael ar gyfer y clip hwn',
  replaceAIMediaSuccess: 'Disodli cyfryngau AI wedi dechrau',
  replaceAIMediaOnlyOneVideo:
    "Dim ond un amnewid fideo sy'n cael ei gefnogi fesul gweithrediad",
  stateDisablingBackgroundAudio: 'Removing background music',
  removeBackgroundMusic: 'Remove background music',
  confirmRemoveBackgroundMusic:
    'This will permanently remove the background music from the video, once the changes are saved.',
  confirmRemoveBackgroundMusicAccept: 'Yes, remove',
  addMedia: 'Ychwanegu cyfryngau',
  addMediaFromLibrary: "Ychwanegu o'r Llyfrgell",
  addMediaFromStoryblocks: 'Ychwanegu o Storyblocks',
  addMediaRemoveAudio: 'Tynnwch sain',
  addMediaPending:
    'Mae ychwanegu cyfryngau yn cymryd mwy o amser nag arfer. Gwiriwch y llinell amser mewn munud.',
  addMediaWait: 'Arhoswch nes bod y prosesu presennol wedi gorffen.',
  editNarrationLoadFailed: 'Methwyd â llwytho testun yr adroddiad',
};

export const VideoEditorText: any = getLocalizationBasedOnLang(english, welsh);
